@if (noRowsSetting()) {
  <mat-form-field
    style="width: 100%"
    [ngStyle]="ngStyle()"
    [appearance]="appearance()"
    [subscriptSizing]="subscriptSizing()"
    [floatLabel]="floatLabel()"
  >
    @if (field().label) {
      <mat-label>{{ field().label }}</mat-label>
    }
    <textarea
      #textarea
      matInput
      [style]="inputTextStyle()"
      [id]="field().id"
      [formControl]="field().control"
      [placeholder]="field().placeHolder"
      [ngStyle]="ngTextareaStyle()"
      (keyup)="onKeyEvent($event)"
    >
    </textarea>
    @if (showLengthHint()) {
      <mat-hint align="end"> {{ textarea.value.length }} / {{ showLengthHint() }} </mat-hint>
    }
    @if (hasErrors) {
      <mat-error>
        {{ validationMessage }}
      </mat-error>
    }
  </mat-form-field>
} @else {
  <mat-form-field
    style="width: 100%"
    [ngStyle]="ngStyle()"
    [appearance]="appearance()"
    [subscriptSizing]="subscriptSizing()"
    [floatLabel]="floatLabel()"
  >
    @if (field().label) {
      <mat-label>{{ field().label }}</mat-label>
    }
    <textarea
      #textarea
      matInput
      cdkTextareaAutosize
      [style]="inputTextStyle()"
      [id]="field().id"
      [placeholder]="field().placeHolder"
      [cdkAutosizeMinRows]="rows()"
      [cdkAutosizeMaxRows]="maxRows()"
      [formControl]="field().control"
      [ngStyle]="ngTextareaStyle()"
      (keyup)="onKeyEvent($event)"
    >
    </textarea>
    @if (showLengthHint()) {
      <mat-hint align="end"> {{ textarea.value.length }} / {{ showLengthHint() }} </mat-hint>
    }
    @if (hasErrors) {
      <mat-error>
        {{ validationMessage }}
      </mat-error>
    }
  </mat-form-field>
}
